import {
  VCTOKEN_ERROR,
  VCTOKEN_LOADING,
  VCTOKEN_SUCCESS,
  VCTOKEN_RESET,
} from "../../ActionTypes";
import axiosInstance from "../../../../global/helpers/axiosInstance";
import axiosToken from "global/helpers/axiosToken";

export const wsGetVcToken = (token, accionToken) => (dispatch) => {
  dispatch({
    type: VCTOKEN_LOADING,
  });

  axiosInstance().then(respuesta => {
  respuesta
  .get(`/TurnoVideoLlamada/vcToken/${token}/${accionToken}`)
  .then((res) => {
    let data = {
      ...res.data,
      origen: "vcToken",
    };
    dispatch({
      type: VCTOKEN_SUCCESS,
      payload: data,
    });
  })
  .catch((err) => {
    let error = {
      detail: err.response
        ? err.response.data
        : "Error al contactar el server.",
      origen: "portal",
    };

    dispatch({
      type: VCTOKEN_ERROR,
      payload: error,
    });
  });
 } )
};

export const vcTokenReset = () => (dispatch) => {
  dispatch({
    type: VCTOKEN_RESET,
  });
};
